import { getCompanyInfo } from './getCompanyInfo';

export const isEnablePhoneSecondStepCopy = (): boolean => {
  const companyInfo = getCompanyInfo();
  // 严格跟随后端灰度开关，字段未返回时不开启。
  return companyInfo.phoneStepRecommendOpen === true;
};
